import { render, staticRenderFns } from "./TheSettingsView.vue?vue&type=template&id=15ea2e76&scoped=true"
import script from "./TheSettingsView.vue?vue&type=script&lang=js"
export * from "./TheSettingsView.vue?vue&type=script&lang=js"
import style0 from "./TheSettingsView.vue?vue&type=style&index=0&id=15ea2e76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ea2e76",
  null
  
)

export default component.exports